export default __webpack_public_path__ + "static/media/rabby.a10a5e51.svg";